<template>
    <PageLayout :loading="regloadingState == 1">
        <component ref="reg" v-if="_config" :is="
        _config.app_config.configValue.template
          ? _config.app_config.configValue.template.register || 'default1'
          : 'default1'
      " />
        <!-- <component ref="reg" v-if="_config" :is="'default1'" /> -->
        <Confirmalert :isShow.sync="isShowRetry" content="页面初始化异常，是否重试？" confirmText="重试" :onCancel="cancel"
            :onConfirm="refresh" />
    </PageLayout>
</template>

<script>
import appConfigMixins from '@c/mixins/appConfig.mixins'
import PageLayout from '@c/layout/PageLayout'
import Confirmalert from '@c/Confirmalert'
export default {
    mixins: [appConfigMixins],
    components: {
        PageLayout,
        Confirmalert,
        default1: () => import('@t/Register/default1'),
        Yabo01: () => import('@t/Register/Yabo01'),
        kszl: () => import('@t/Register/kszl'),
        kslight: () => import('@t/Register/kslight'),
        ksob: () => import('@t/Register/ksob'),
        ob: () => import('@t/Register/ob'),
        nox: () => import('@t/Register/nox'),
        dfcp: () => import('@t/Register/dfcp'),
    },
    data() {
        return {
            reloadOverlay: false,
            isShowRetry: false
        }
    },
    watch: {
        regloadingState(val) {
            if (val == 3) {
                this.isShowRetry = true
            }
        }
    },
    methods: {
        cancel() {
            this.routeBack({ numb: -1 })
        },
        refresh() {
            this.$refs.reg.init()
        }
    },
    computed: {
        regloadingState: {
            get() {
                return this.$store.state.user.regloadingState
            },
            set(val) {
                this.$store.commit('user/setRegloadingState', val)
            }
        }
    }
}
</script>

<style scoped>
.btn-back {
    left: 30px;
    position: absolute;
    top: 13vw;
}
</style>